export const USER_DETAILS_KEY = "zTaskUserDetails";

export const hasPermission = async (module, action) => {
  const storedUserDetailsString = localStorage.getItem(USER_DETAILS_KEY);
  const userDetails = JSON.parse(storedUserDetailsString);

  return userDetails.role.permissions.some(
    (p) =>
      p.title ===
      `${action.toUpperCase()} ${module.split("-").join(" ").toUpperCase()}`
  );
};
